import gql from 'graphql-tag';

export default gql`
  mutation clientAddSellingList($input: ClientAddSellingListInput) {
    clientAddSellingList(input: $input) {
      userErrors {
        field
        message
      }
      success
    }
  }
`;
